
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/panning.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-graph-panning-demo-api-graph-panning"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/panning.en.md?type=demo')
};